// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1krJw","errorLogs":"styles_errorLogs__1cK4R"};